
const en = {
    message: {
        title1:'Remote control of smart home, technology, safety and peace of mind',
        content1:' AigoSmart helps you to remotely manage and control home smart appliances, and the devices can also perceive and link each other. One-click triggering can make all home appliances enter your preset state, creating a safe and worry-free smart home for you life. ',
        title2: "AigoSmart is a new sub-brand of Aigostar",
        content2: "The products are currently sold to Spain, Portugal, France, Italy, the Netherlands, Germany, Finland, Denmark, Poland, Russia, Greece, Austria, Switzerland, Czech Republic, Hungary, Slovakia and other European countries and regions.",
        content3: "AIGOSTAR's various kitchen, laundry and ironing small household appliances continue to occupy",
        content4: "Top ten sales.",
        title3: "Brand Honor",
        content5: "Fast. Open. Innovate. Persevere",
        loading:'Loading',
        submit:'Submit',
        contactUs: "Contact Us",
        privacy:"Privacy Agreement",
        policy:"Service Policy",
        download:"Download",

    },
}

export default en;